const registered = () => ({
    iddevice: null,
    nomor: "",
    nama: "",
    auto_renewal: 1,
    id_paket: null,
    jenis_pembayaran: "",
    kode_kupon: "",
    country_code: "62",
    price: 150000,
    idoutlet: null,
});

export default registered;
